import React from 'react'
import { graphql } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { BlocksRenderer } from '@strapi/blocks-react-renderer'
import { HtmlTag, Cta } from '../libs/helpers'

import * as styles from './teaser.module.scss'

const Teaser = ({ title, description, image, jumplink, theme, ctas, children }) => {
  const img = image ? getImage(image.localFile) : undefined

  return (
    <section id={jumplink ? jumplink : null} className={styles[theme]}>
      <div className={styles['inner']}>
        {image && (
          <div className={styles['image']}>
            <GatsbyImage image={img} alt={img.alternativeText || 'alt'} />
          </div>
        )}
        <div className={styles['content']}>
          {title && (
            <div className={styles['title']}>
              <HtmlTag tagName={title.header}>{title.copy}</HtmlTag>
            </div>
          )}
          {description && (
            <div className={styles['description']}>
              <BlocksRenderer content={description} />
            </div>
          )}
          {children && children}
          {ctas && ctas.length > 0 && (
            <div className={styles['ctas']}>
              {ctas.map((cta, i) => (
                <Cta key={i} cta={cta} />
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default Teaser

export const query = graphql`
  fragment TeaserData on STRAPI__COMPONENT_COMPONENT_TEASER {
    ctas {
      href
      label
      page {
        path
        title
      }
    }
    description {
      children {
        bold
        children {
          bold
          children {
            text
            type
          }
          text
          type
          url
        }
        italic
        text
        type
        url
      }
      format
      image {
        alternativeText
        url
      }
      level
      type
    }
    image {
      alternativeText
      localFile {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
    jumplink
    theme
    title {
      copy
      header
    }
  }
`
